module.exports = __webpack_public_path__ + "img/Group 319.190bb87e.png";